import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WEB_APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Party - Get All (Read)
export const GetAll = createAsyncThunk(
    "masters/Party/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Masters.Party}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Party - Get (Read)
export const GetSingle = createAsyncThunk(
    "masters/Party/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Party}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetPartyTransactions = createAsyncThunk(
    "masters/Party/get-ts",
    async ({ id, filter }, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Party}/transactions/${id}?name=${filter?.name || ""}&endDate=${filter?.endDate || ""}&startDate=${filter?.startDate || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`);
            return res?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Party - Create (Add)
export const Create = createAsyncThunk(
    "masters/Party/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Masters.Party, data);

            if (res.success) {

                return res; // The new Party object
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

// Party - Update
export const Update = createAsyncThunk(
    "masters/Party/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${WEB_APIS.Masters.Party}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Party - Delete
export const Delete = createAsyncThunk(
    "masters/Party/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Masters.Party}/${id}`);
            return id; // Return the id of the deleted Party
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Party - Status
export const Status = createAsyncThunk(
    "masters/Party/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Party}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const CreateNote = createAsyncThunk(
    "masters/Party/createNote",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Party}/note`, data);

            if (res.success) {

                return res; // The new Party object
            }
            return rejectWithValue(res);
        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

export const DeleteNote = createAsyncThunk(
    "masters/Party/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Masters.Party}/note/${id}`);
            return id; // Return the id of the deleted Party
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "Party",
    initialState: {
        data: [],
        transactions: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetPartyTransactions.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetPartyTransactions.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.transactions = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetPartyTransactions.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (Party) => Party.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (Party) => Party.id !== action.payload.id
                ); // Remove the Party with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (Party) => Party.id !== action.payload.id
                ); // Remove the Party with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
